/**
 * Whitelist of Lumera-tool action types the resourceful Companion can emit.
 * MUST stay in sync with `VALID_ACTION_TYPES` in
 * `/app/backend/lumera_companion_service.py::_enrich_response`.
 *
 * If you add a new action type, you must update:
 *   1) backend whitelist (validation + dropping invalid entries)
 *   2) the Companion system-prompt tool list (so the LLM knows about it)
 *   3) the `ICONS` map in CompanionActions.jsx
 *   4) the `urlFor` switch in CompanionActions.jsx
 */
export const COMPANION_ACTION_TYPES = Object.freeze([
  'open_verse',        // /bible?book=&chapter=&verse=
  'word_study',        // /word-study?word=  | ?strongs=
  'mh_commentary',     // /dashboard?tool=commentary&book=&chapter=
  'sermon_prep',       // /sermon-prep?topic=
  'play_game',         // /community?tab=games&game=
  'view_highlights',   // /highlights
  'preach_mode',       // /sermon-prep/present?draft_id=
  'verse_lens',        // Opens the unified Verse Lens popover via custom event
  'view_chronology',   // /chronology?section=
  'cross_refs',        // /cross-references?book=&chapter=&verse=
]);
